//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    dialogComponent: {
      type: [Object, Boolean, Function],
      default: undefined,
    },
    dialogStackLength: {
      type: Number,
      default: 0,
    },
    dialogPopValue: {
      type: [Number, String],
      default: undefined,
    },
    dialogParams: {
      type: Object,
      default: undefined,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    popDialog: {
      type: Function,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
  },
};
